import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { PageLoadingIndicator } from '@components/page-loading-indicator';

const { lazy } = React;
const UserCidnAssociationPageComponent = lazy(() => import(/* webpackChunkName:"user-cidn-association" */'./index'));

export const UserCidnAssociation = () => {
    return (
        <LazyLoadComponentWrapper
            fallback={<PageLoadingIndicator error={false} />}
            errorIndicator={<PageLoadingIndicator error={true} />}>
            <UserCidnAssociationPageComponent />
        </LazyLoadComponentWrapper>
    );
};
